import { VendorBuyingAgreementBuyOpportunitiesList } from '../../../components/Vendor';

export function BuyingAgreementBuyOpportunities() {
  return <VendorBuyingAgreementBuyOpportunitiesList />;
}
